/**
 * The court a wizard runs for: its courts.json entry, its court-layer details
 * (src/courts/) and its calendar. mountWizard builds one and passes it to a wizard's
 * steps, summary(answers, court) and build(answers, court).
 */
import { COURT_DETAILS } from "../courts/index.js";
import { calendarFor } from "./courtdays.js";

/**
 * `entry` is the court's row in src/content/courts.json (a bare id works too).
 * Returns { id, name, hasLocalData, holidays, details, calendar }. `name` is the courts.json
 * name, which checklists use to name the court.
 */
export function courtContext(entry) {
  const row = typeof entry === "string" ? { id: entry } : entry || {};
  const local = COURT_DETAILS[row.id] || {};
  const court = {
    id: row.id,
    name: row.name || row.id || "the court",
    hasLocalData: !!COURT_DETAILS[row.id],
    holidays: local.holidays || null,
    details: local.details || {},
  };
  court.calendar = calendarFor(court);
  return court;
}

/**
 * The court's value for one detail, or a "verify" item naming the court when it has none.
 *
 *   courtDetail(court, "departments.lawAndMotion", "local rules for the department that hears demurrers")
 *
 * returns the Detail ({ text, cite, forms, value }) with known: true, or
 *   { known: false, text: "", cite: "", forms: [], verify: "For Superior court of California - County of Fresno, check the local rules for the department that hears demurrers." }
 */
export function courtDetail(court, path, what) {
  const found = path.split(".").reduce((o, k) => (o && typeof o === "object" ? o[k] : undefined), court && court.details);
  if (found && found.text) return { forms: [], ...found, known: true };
  return { known: false, text: "", cite: "", forms: [], verify: `For ${(court && court.name) || "the court"}, check the ${what}.` };
}
